module.exports = __webpack_public_path__ + "static/media/org-icon-selected.59a1c2bc.svg";